import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { jkLib } from './jkCommon';
import { jkRestReturnClass } from './jkClass';

/*enum FileUploadMode {
  Instant = 'instant',
  UseForm = 'useForm',
  UseButtons = 'useButtons',
}
enum FileUploadMethod {
  Post = 'POST',
  Put = 'PUT',
}*/

export class uploadOptionClass {
  accept: string; // '*' | 'vedio/*' | 'image/*' | 'audio/*'
  uploadUrl: string;
  multiple: boolean;
  maxFileSize: number;
  allowedFileExtensions: string[];
  uploadMode: string = ''; // FileUploadMode; // 'instantly' | 'useButtons' | 'useForm'
  uploadMethod: string = ''; // UploadHttpMethod; // 'POST' | 'PUT'

  constructor() {
    this.accept = '*';
    this.uploadUrl = '';
    this.multiple = false;
    this.maxFileSize = 0;
    this.allowedFileExtensions = [];
    /* "instantly" (default)
      Ajax upload. Files are uploaded after they are selected.
      "useButtons"
      Ajax upload. Files are uploaded after a user clicks the Upload button.
      "useForm"
      HTML form upload. Files are uploaded when the HTML form is submitted.
      */
    this.uploadMode = 'useButtons'; //FileUploadMode.UseButtons;
    this.uploadMethod = 'POST'; // FileUploadMethod.Post;
  }
}

@Injectable({
  providedIn: 'root',
})
export class UploadService extends uploadOptionClass {
  private http = inject(HttpClient);

  opt: uploadOptionClass= new uploadOptionClass(); // DxFileUploaderComponent | undefined;
  uploadFiles: any[] = [];
  fileObj: File | undefined;
  programId: string = '';
  uid: string = '';
  init(uid:string,programId:string, opt: uploadOptionClass) {
    jkLib.cloneObject(opt, this.opt);
    this.programId = programId;
    this.uid = uid;
  }
  getFileName():string {
    let result = '';
    let n = this.uploadFiles.length;
    if(n===0) return '';
    for(let i=0;i<n;i++) {
      if(i>0) result += ',';
      result += this.uploadFiles[i].name;
    }
    return result;
  }
  async fileUploader_uploadFile(xfile: any, progressCallback: any) {
    let n = this.uploadFiles.length;
    if(n===0) return;

    // your code
    if(progressCallback)
      progressCallback(100);
    // ...
    if(progressCallback)
      progressCallback(200);
    // ...
    if (n > 0) {
      this.fileObj = this.uploadFiles[0];
    } else {
      alert('請選擇檔案');
      return;
    }

      if (this.fileObj) {
        let formData = new FormData();

        formData.append('fileupload', this.fileObj);
        formData.append('filename', this.fileObj.name);
        formData.append('userid', this.uid);
        formData.append('programid', this.programId);
        const httpOptions = {
          headers: new HttpHeaders({
          'Content-Type': 'application/json'
          })
         };
        let upload$ =  this.http.post<jkRestReturnClass>(this.uploadUrl, formData);
        upload$.subscribe();// 到底要如何等待回傳值呢?
        //let ret = await upload$.toPromise();
        //console.log(ret);
        /*const upload$ = this.http.post(
          this.uploadUrl, // 'http://localhost:9086/api/upload_devextreme',
          formData
        );
        upload$.subscribe();
        */
      }
    }

}
